import { Button, Callout, Tag } from '@dev-spendesk/grapes';
import { useEffect, useState } from 'react';

import { useGoTo } from 'src/core/common/hooks/useGoTo';
import { LocalStorageKey } from 'src/core/constants/storage';

import { useFeature } from '../../../common/hooks/useFeature';
import { useTranslation } from '../../../common/hooks/useTranslation';
import FEATURES from '../../../constants/features';
import { useCompanyId } from '../../app/hooks/useCompanyId';
import { useUser } from '../../app/hooks/useUser';
import { useGetWiseKycStatus } from '../transfer/hooks';

export function WiseIntegrationBanner() {
  const { t } = useTranslation('global');
  const goTo = useGoTo();

  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const isDismissedLocalStorage = localStorage.getItem(
      LocalStorageKey.WiseIntegrationBannerDismissed,
    );
    if (isDismissedLocalStorage) {
      setIsDismissed(true);
    }
  }, []);

  const companyId = useCompanyId();

  const user = useUser();

  const isUserOwner = user.is_account_owner || user.is_organisation_owner;

  const isUserController = user.is_controller;

  const hasUkInternationalWiretransferFeature = useFeature(
    FEATURES.TMP_UK_INTERNATIONAL_WIRE_TRANSFER,
  );

  const { data: kycStatus, isLoading: isKycLoading } = useGetWiseKycStatus({
    companyId,
    enabled: hasUkInternationalWiretransferFeature,
  });

  const handleGoToWiseButton = async () => {
    goTo(
      'COMPANY_INTEGRATIONS_ALL',
      {
        company: companyId,
      },
      new URLSearchParams({ selected: 'wise' }),
    );
  };

  const handleCloseClick = () => {
    localStorage.setItem(
      LocalStorageKey.WiseIntegrationBannerDismissed,
      'true',
    );
    setIsDismissed(true);
  };

  if (
    isKycLoading ||
    !hasUkInternationalWiretransferFeature ||
    (!isUserOwner && !isUserController) ||
    kycStatus || // If there is a kycStatus, we display another banner to ask the user to pick up where he left
    isDismissed
  ) {
    return null;
  }

  return (
    <Callout
      title={
        <span className="flex flex-row">
          <p>{t('invoices.transfer.wiseStartIntegrationBanner.title')}</p>
          <Tag className="ml-12" variant="ocean">
            {t('misc.new')}
          </Tag>
        </span>
      }
    >
      <div className="flex flex-col gap-16">
        <p className="white-space-pre-wrap">
          {t('invoices.transfer.wiseStartIntegrationBanner.body1')}
          {` ${isUserOwner ? t('invoices.transfer.wiseStartIntegrationBanner.body1AccountOwner') : t('invoices.transfer.wiseStartIntegrationBanner.body1Controller')}`}
        </p>

        <div className="flex">
          {isUserOwner && (
            <>
              <Button
                className="mr-16 self-start"
                text={t('invoices.transfer.wiseStartIntegrationBanner.button')}
                onClick={handleGoToWiseButton}
              />
            </>
          )}
          <Button
            variant="tertiaryBrand"
            className="pl-0"
            text={t(
              'invoices.transfer.wiseStartIntegrationBanner.notInterested',
            )}
            onClick={handleCloseClick}
          />
        </div>
      </div>
    </Callout>
  );
}
